import { values, groupBy } from 'underscore';
import TourProduct from '../model/TourProduct';

export default function (tourProducts: TourProduct[]): TourProduct[][] {
    return values(groupBy(tourProducts, (tourProduct) => tourProduct.hotel?.id || ''));
}